export const getFormStatusByType = type => state => state.forms.status[type];
export const getFormResponseByType = type => state => state.forms.response[type];
